export default __webpack_public_path__ + "static/media/flying.206bea18.svg";